const ItemConstants = {};

ItemConstants.STATUS = {
  ACTIVE: 'Active',
  SPECIAL_ORDER: 'Special Order',
  DISCONTINUED: 'Discontinued',
  KIT: 'Kit',
}

export default ItemConstants;